import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationsState } from '../../states/investigations.state';
import { UpdateInvestigationAssigneesCommand } from './update-investigation-assignees.command';

@Injectable({ providedIn: 'root' })
export class UpdateInvestigationAssigneesUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _state = inject(InvestigationsState);

  public execute(command: UpdateInvestigationAssigneesCommand): Observable<void> {
    this._state.setSavingAssignees(true);

    return this._repository.updateAssignees(
      command.investigationId,
      command.primaryAssigneeUserId,
      command.secondaryAssigneeUserId,
    ).pipe(
      tap(() => {
        this._state.setSavingAssignees(false);
      }),
      catchError((error) => {
        this._state.setSavingAssignees(false);
        return throwError(() => error);
      }),
    );
  }
}
